import React from "react";
import './directorio.css';

const Directorio1 = ({titulo}) => {
return(
<div className="container container-mh">
<div className="title">
<h1> Directorio Institucional de la Secretaría De Movilidad y Transporte</h1>
<br></br>
<hr className="hr-gob" />
<p></p>
<div className='row'>
<div class="col-sm-4 col-12"></div>
<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("https://cdn.hidalgo.gob.mx/gobierno/images/gabinete/LyzbethRoblesGutierrez.png")'}}>
</div>
</div>
    <h4>Mtra. Lyzbeth Robles Gutiérrez</h4>
    <p></p>
    <h6> Titular de la Secretaría de Movilidad y Transporte</h6>
    <p></p>
    <h6>✆ Telefono (771) 717 6000 Ext</h6>
    <p></p>
    <h6>lyzbethrobles@hidalgo.gob.mx</h6>
    <p></p>
</div>
</div>
</div>
<p></p>
<br></br>
<hr className="hr-gob" />
<div className='row'>
<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("https://s-gobierno.hidalgo.gob.mx/Img/titular.png")'}}>
</div>
</div>
    <h4>Mtra. Rosenda Sánchez Sánchez</h4>
    <p></p>
    <h6>Titular de la Dirección General de Normatividad</h6>
    <p></p>
    <h6>✆ Telefono: (771) 717 6000 Ext. 1844</h6>
    <p></p>
    <h6>rosendasanchez@hidalgo.gob.mx</h6>
    <br></br>
    <p></p>
    </div>
</div>
<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("https://s-gobierno.hidalgo.gob.mx/Img/titular.png")'}}>
</div>
</div>
    <h4>L.A. León Maximiliano Hernández Valdés </h4>
    <p></p>
    <h6>Titular de la Dirección General de Administración y Finanzas</h6>
    <p></p>
    <h6>✆ Telefono (771) 717 6000 Ext. 2265</h6>
    <p></p>
    <h6>maximiliano.hernandez
        @hidalgo.gob.mx</h6>
</div>
</div>

<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("https://s-gobierno.hidalgo.gob.mx/Img/titular.png")'}}>
</div>
</div>
    <h4>Dr. Jóse Antonio Pérez Sánchez </h4>
    <p></p>
    <h6>Titular de la Dirección General de Movilidad Sustentable</h6>
    <p></p>
    <h6>✆ Telefono: (771) 717 6000 Ext. </h6>
    <p></p>
    <h6>jose.perez@hidalgo.gob.mx</h6>
    <br></br>
    </div>
</div>
</div>
<p></p>
<br></br>
<hr className="hr-gob" />
<div className='row'>
<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("https://s-gobierno.hidalgo.gob.mx/Img/titular.png")'}}>
</div>
</div>
    <h4>Mtra. Fátima Monserrath Morelos Esquivel  </h4>
    <p></p>
    <h6>Secretaria Técnica</h6>
    <p></p>
    <h6>✆ Telefono (771) 717 6000 Ext</h6>
    <p></p>
    <h6>fatima.morelos@hidalgo.gob.mx</h6>
    
    
</div>
</div>
<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("./assets/imgs/directorio/2.png")'}}>
</div>
</div>
    <h4>Lic. Luis Armando Pichardo Blanquel</h4>
    <p></p>
    <h6>Titular de la Dirección de Gestión Institucional</h6>
    <p></p>
    <h6>✆ Telefono (771) 717 6000 Ext</h6>
    <p></p>
    <h6>luispichardo@hidalgo.gob.mx</h6>
    
</div>
</div>

<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("https://s-gobierno.hidalgo.gob.mx/Img/titular.png")'}}>
</div>
</div>
    <h4>Lic. José Carlos Ramírez Rivera</h4>
    <p></p>
    <h6>Titular de la Dirección de Planeación y Evaluación</h6>
    <p></p>
    <h6>✆ Telefono (771) 717 6000 Ext. 1839</h6>
    <p></p>
    <h6>carlos.ramirez@hidalgo.gob.mx</h6>
    <br></br>
</div>
<br></br>
</div>

<div class="col-sm-4 col-12"></div>
<div class="col-sm-4 col-12">
<div class="card-noticias">
<div className='secretaria_logo2' >
<div className='secretaria_logo_img2' style={{backgroundImage: 'url("./assets/imgs/directorio/2.png")'}}>
</div>
</div>
    <h4>L.A.E.T. Ricardo Bravo Pérez </h4>
    <p></p>
    <h6>Titular de la Dirección de Movilidad Sustentable</h6>
    <p></p>
    <h6>✆ Telefono (771) 717 6000 Ext</h6>
    <p></p>
    <h6>ricardo.bravo@hidalgo.gob.mx</h6>
</div>
</div>
<p></p>
<br></br>
<br></br>
<hr className="hr-gob" />
</div>		
</div> 
</div>	
)
}
export default Directorio1